const url = 'schools';

export default server => ({
    async all() {
        let {data} = await server.get(url);
        return data;
    },
    async store(fields) {
        console.log('🤯🤯🤯🤯')
        let {data} = await server.post(url, fields);
        return data;
    },
    async update(school_id, fields) {
        let {data} = await server.patch(`${url}/${school_id}`, fields);
        return data;
    },
    async destroy(school_id) {
        let {data} = await server.delete(`${url}/${school_id}`);
        return data;
    },
});